import React from 'react';
import { SvgIcon } from '../components/svgIcon';
import { SvgIconProps } from '../components/svgIcon/model';

export const BellFilledIcon = React.forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <SvgIcon cacheName="bellFilled" ref={ref as any} {...props}>
      <path
        d="M17.599 9.45C17.599 12.6454 17.8822 13.649 19.764 15.6491C20.268 16.1846 19.9112 17.1 19.1984 17.1H14.7589L14.7992 17.525C14.7992 19.1681 13.5459 20.5 11.9998 20.5C10.4536 20.5 9.2003 19.1681 9.2003 17.525L9.24058 17.1H4.8014C4.08887 17.1 3.73206 16.1846 4.23578 15.6491C5.28725 14.5313 5.85712 13.5895 6.13471 12.6058C6.35793 11.8161 6.40112 11.1729 6.40112 9.45C6.40112 6.16392 8.90777 3.5 12 3.5C15.0923 3.5 17.599 6.16389 17.599 9.45Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});
